import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Typography} from '@mui/material';
import {APIError} from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import DefinitionSection from '~common/form/definition-section';
import {Definition} from '~common/lib/types';
import {setValueAtPath} from '~common/form/helper';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
  taskCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    minHeight: 200
  },
  caption: {
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    padding: 10
  },
  cardContent: {
    margin: '10px 15px 10px 15px'
  },
  countContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    cursor: 'pointer'
  },
  templateContent: {
    minHeight: 120
  },
  cardContentEven: {
    margin: '10px 15px 10px 15px',
    display: 'flex',
    justifyContent: 'space-around'
  },
  cardActions: {
    padding: 5
  }
});

interface Props {
  history:any;
  id: number;
  caption: string;
  renderers: any;
  element: any;

  chromeless?: boolean;

  //results is the results that were showing when the card was created.  This is useful for capturing attributes like ggregationAttributes.
  results: any;
}

type State = {
  status: 'loading' | 'ready';
  configData: any;
  policyMessages: Array<any>;
  error?: any;
};

class CountEditor extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  
  static register = () => {
    if(!Renderers.find("CountConfigRenderer")){
      Renderers.register("CountConfigRenderer", CountEditor)
    }
  }

  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      configData: props.element
    };
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

 componentDidMount() {
    this.setState({status: 'ready'});
  }

  // handleChangeAtPath is used to ferry changes from owned components upstream
  handleChangeAtPath = (path: string, value: any) => {



      let {configData} = this.state;

      let svpResp = setValueAtPath(path, configData, value);
      configData = svpResp.data;
  
      if (svpResp.err) {
        console.error(svpResp.err);
      }

      this.setState({configData}, ()=>{
        if(this.props.onConfigChange){
          this.props.onConfigChange(configData)
        }
        this.clearMessagesAtPath(path)
      });

  };

  // clearMessagesAtPath helps to show user progress by clearing messages for a path as the user updates the value at the path
  clearMessagesAtPath = (path:string) => {
    const {policyMessages} = this.state
    if(policyMessages && policyMessages.length>0){
      const pm = policyMessages.reduce((acc, m)=>{
        let mp = m.path 
        if(mp.indexOf("/")==0){
          mp = mp.substring(1)
        }

        let op = path 
        if(op.indexOf("/")==0){
          op = op.substring(1)
        }

        if (mp != op) {
          acc.push(m)
        }

        return acc
      }, [])

      this.setState({policyMessages:pm})
    }
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless} = this.props;
    const {status, configData, policyMessages} = this.state;


    // Make sure title is still centered after icon placment
    return (
      <div>
        <DefinitionSection
          data={configData}
          definition={countForm}
          path={''}
          policyMessages={policyMessages}
          onChangeAtPath={this.handleChangeAtPath}
          gridSpacing={3}
          suppressTitle={true}
        />
      </div>
    );
  }
}

var countForm: any = new Definition({
  key: 'countForm',
  title: 'Count Form',
  predefined: [
    {
      gridAttributes: {
        lg: 12,
        md: 12,
        newRow: true,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'title',
      mode: 'Required',
      title: 'Card Title',
      type: 'Text'
    },
    {
      gridAttributes: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'elementType',
      mode: 'Hidden',
      defaultValue: 'Count',
      options: [
        {
          label: 'Count',
          value: 'Count'
        },
        {
          label: 'Template',
          value: 'Template'
        },
        {
          label: 'Form',
          value: 'Form'
        },
        {
          label: 'Chart',
          value: 'Chart'
        }
        // {
        //   "label": "List",
        //   "value": "List"
        // }
      ],
      title: 'Card Type',
      type: 'Text'
    },
    {
      conditionalAttributes: [
        {
          attributeName: 'mode',
          attributeValue: 'Required',
          operator: '==',
          path: 'elementType',
          value: 'Template'
        }
      ],
      gridAttributes: {
        lg: 12,
        md: 12,
        newRow: true,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'template',
      mode: 'Hidden',
      title: 'Template',
      type: 'Text',
      variant: 'TextArea'
    },
    {
      conditionalAttributes: [
        {
          attributeName: 'mode',
          attributeValue: 'Required',
          operator: '==',
          path: 'elementType',
          value: 'Chart'
        }
      ],
      gridAttributes: {
        lg: 12,
        md: 12,
        newRow: true,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'categoryAttribute',
      mode: 'Hidden',
      title: 'Category Attribute',
      type: 'Text'
    }
  ],
  user: [],
  definitions: []
});

export default withStyles(styles)(CountEditor);
